import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import FormInput from '../../components/elements/form_input';
import Button from '../../components/elements/button';
import { Mail, Security,} from '../../assets/icons';
import arrow from '../../assets/icons/arrow_right.svg'
import tape from '../../assets/icons/yellow_rectangle.svg'
import { authApi } from '../../network/apis/auth';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');
        
        try {
            const response = await authApi.forgotPassword(email);
            console.log('Response:', response);
            if (response?.status === 'success') {
                setIsSubmitted(true);
                // Store email for use in reset password page
                sessionStorage.setItem('resetEmail', email);
            } else {
                setError(response?.message || 'Failed to process request');
            }
        } catch (error) {
            console.error('Error:', error);
            setError(error?.message || 'Failed to process request. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleContinueToReset = () => {
        navigate('/reset-password');
    };

    const handleResendCode = async () => {
        setIsLoading(true);
        setError('');
        try {
            await authApi.resendResetCode(email);
            setError(''); // Clear any previous errors
            alert('A new reset code has been sent to your email.');
        } catch (error) {
            setError('Failed to resend code. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="auth-container">
            <section className="auth-right">
                <div className="right-inner">
                    <h3 className="right-inner-title">A platform tailored for the Modern Fish Farmer</h3>
                    <p className="right-inner-text">Every missing person deserves to be found. Together, we can make a difference. Explore our report sightings, and offer support to reunite families with their loved ones.</p>
                    <button className="learn-more-btn">Learn More &nbsp; <img src={arrow} alt="arrow" className="arrow_up"/></button>
                    <img src={tape} alt="" className="tape" />
                </div>
            </section>
            <section className="auth-section">
                <div className="auth-logo-section">
                    E-AQUAHEALTH
                    <img src={Security} alt="security"/>
                </div>
                
                {!isSubmitted ? (
                    <>
                        <h3 className="auth-title">Forgot Password</h3>
                        <p className="auth-subtitle">Enter your email to reset your password</p>
                        
                        {error && <div className="auth-error">{error}</div>}
                        
                        <form onSubmit={handleSubmit} className="auth-form">
                            <FormInput
                                id="email"
                                label="Email"
                                required={true}
                                icon={<img src={Mail} alt="email"/>}
                                placeholder="Enter your email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                type="email"
                            />
                            <Button 
                                text={isLoading ? "Sending..." : "Send Reset Code"} 
                                type="submit"
                                fullWidth
                                loading={isLoading}
                                disabled={isLoading}
                            />
                            
                            <div className="back-to-login">
                                <Link to="/login">← Back to Login</Link>
                            </div>
                        </form>
                    </>
                ) : (
                    <div className="reset-sent">
                        <h3>Check Your Email</h3>
                        <p>We've sent a 6-digit verification code to <strong>{email}</strong></p>
                        <p className="code-expiry">The code will expire in 15 minutes.</p>
                        
                        <div className="reset-actions">
                            <Button 
                                text="Continue to Reset Password" 
                                onClick={handleContinueToReset}
                                fullWidth
                            />
                            <button 
                                className="resend-link"
                                onClick={handleResendCode}
                                disabled={isLoading}
                            >
                                {isLoading ? 'Sending...' : "Didn't receive the code? Resend"}
                            </button>
                        </div>
                    </div>
                )}
            </section>
        </div>
    );
};

export default ForgotPassword;